import React from "react";
import { Box, Typography } from "@mui/material";
import { CampaignConfigDetailsProps } from "../../../interfaces/campaignConfig";

const DocumentGenerationDetails: React.FC<CampaignConfigDetailsProps> = ({ inputsState, optionsCache }) => {
    const templates = optionsCache['campaign_config_name'] || [];
    const selectedTemplate = templates.find(
        (t: any) => t.template_name === inputsState['campaign_config_name']
    );
    return (
        <Box mt={3} display="flex" flexDirection="column" alignItems="center">
            <Typography variant="subtitle2" gutterBottom>Template Preview</Typography>
            {selectedTemplate?.thumbnail_url ? (
                <Box 
                    sx={{ 
                        border: '1px solid', 
                        borderColor: 'divider', 
                        borderRadius: 1, 
                        p: 1
                    }}
                >
                    <img 
                        src={selectedTemplate.thumbnail_url} 
                        alt={`${selectedTemplate.template_name} preview`}
                        style={{ 
                            maxWidth: '200px', 
                            maxHeight: '280px',
                            display: 'block'
                        }}
                    />
                </Box>
            ) : (
                <Typography variant="body2" color="text.secondary">
                    No preview available
                </Typography>
            )}
        </Box>
    );
};

export default DocumentGenerationDetails;
